import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute, Params } from '@angular/router';
import { DistributorService } from '../../../distributor.service';
import { CardTabUtilsService } from '../../../components/card-tab-section/card-tab-utils.service';
import { EnumDistributorSectionCard } from '../../../enum/label-section.enum';
import { CardSectionEnums, ICardTabSection } from '../../../components/card-tab-section/card-tab-section.interface';
import { IDetailPlafonKreditV1 } from '../../../interfaces/detail-plafon-kredit.interface';

@Component({
  selector: 'app-tab-plafon-kredit',
  templateUrl: './tab-plafon-kredit.component.html',
  styleUrls: ['./tab-plafon-kredit.component.scss'],
})
export class TabPlafonKreditComponent implements OnInit {
  isLoading = new BehaviorSubject(false);
  snapshotParams!: Params;

  detailPlafonSubject = new BehaviorSubject({} as IDetailPlafonKreditV1);

  //sections data
  bodyCreditCeilingGranted = new BehaviorSubject({ cardTitle: 'Plafon yang Diberikan' } as ICardTabSection<typeof CardSectionEnums.EnumCardSectionCreditCeilingGranted>);
  bodySaleTarget = new BehaviorSubject({ cardTitle: 'Target Penjualan' } as ICardTabSection<typeof CardSectionEnums.EnumCardSectionSaleTarget>);
  bodyCreditBilling = new BehaviorSubject({ cardTitle: 'Penagihan Kredit' } as ICardTabSection<typeof CardSectionEnums.EnumCardSectionSaleTarget>);

  constructor(private activatedRoute: ActivatedRoute, private distributorService: DistributorService, private cardTabUtilsService: CardTabUtilsService) {}

  ngOnInit() {
    this.snapshotParams = this.activatedRoute.snapshot.params;
    this.getDetail();
  }

  getDetail() {
    this.isLoading.next(true);
    this.distributorService.getDetailPlafonKredit(this.snapshotParams.id).subscribe((resp) => {
      if (!resp) return;
      this.detailPlafonSubject.next(resp && resp.data);
      this.mapBodyGroupData();
      this.isLoading.next(false);
    });
  }

  mapBodyGroupData() {
    const _data = this.detailPlafonSubject.value;
    for (const _k in _data) {
      if (_data.hasOwnProperty(_k)) this.generateBodyData(_k as EnumDistributorSectionCard, _data);
    }
  }

  generateBodyData(key: EnumDistributorSectionCard, data: IDetailPlafonKreditV1) {
    const enumSection = this.cardTabUtilsService.getEnumSection(key);
    const bodySubject = this.getBodySubject(key);

    if (!bodySubject && !enumSection) return;

    const _bodyGroup = this.cardTabUtilsService.generateCardBodyGroup(key as keyof typeof data, data, this.snapshotParams.status);
    bodySubject.next({
      ...bodySubject.value,
      cardEnum: key,
      cardBodyGroup: _bodyGroup,
    });
  }

  getBodySubject(key: EnumDistributorSectionCard) {
    const subjectMap: Record<
      EnumDistributorSectionCard.credit_ceiling_granted | EnumDistributorSectionCard.sale_target | EnumDistributorSectionCard.credit_billing,
      BehaviorSubject<any>
    > = {
      [EnumDistributorSectionCard.credit_ceiling_granted]: this.bodyCreditCeilingGranted,
      [EnumDistributorSectionCard.sale_target]: this.bodySaleTarget,
      [EnumDistributorSectionCard.credit_billing]: this.bodyCreditBilling,
    };

    return subjectMap[key as keyof typeof subjectMap];
  }
}
